import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
var Flickity = require('flickity');
require('flickity-fullscreen');
import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'

import './selects'

import './tab'

import './front-page'

import './header'

import './popup'

import './ie11'

import './content'

import './load-more'

objectFitImages()

jQuery.fancybox.defaults.animationEffect = 'fade'
jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]

jQuery('.content iframe').reframe()

if (jQuery('.intro').hasClass('intro--with-image')) {

} else {

    if (jQuery('body').hasClass('home') ) {

    } else {

        jQuery('.header').addClass('header--default-white')

    }
}

const gallerySlider = jQuery('.wp-block-gallery'),
    galleryItems = jQuery('.wp-block-gallery .wp-block-image')

if (gallerySlider.length > 0 && galleryItems.length > 1) {

    var flkty = new Flickity( '.wp-block-gallery', {
        cellSelector: '.wp-block-image',
        prevNextButtons: true,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left',
        lazyLoad: 1,
        groupCells: 1,
        fullscreen: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
    });

}
